var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var Tour = require('../../../include/search/_js/Tour');

        var FIND_TYPE_DEFAULT = 0;
        var FIND_TYPE_MAGNIFIER = 1;
        var FIND_TYPE_RECOUNT = 2;
        var FIND_TYPE_PRICE_CHECK = 3;
        var FIND_TYPE_RESERVATION = 4;

        var Search = function () {
            function Search() {
                _classCallCheck(this, Search);

                window.baseSearchRequest = new window.search.Request({});
                window.baseSearchRequest.tourUnpack = function (t, searchReq) {
                    return new Tour(t, searchReq);
                };

                this.attachHandlers();
            }

            _createClass(Search, [{
                key: "attachHandlers",
                value: function attachHandlers() {
                    window.addEventListener('startNewSearch', function (event) {
                        Search.startSearch(event.detail.formParams);
                    });
                    window.addEventListener('startAdditionalSearch', function (event) {
                        Search.startSearch(event.detail.formParams);
                    });
                    window.addEventListener('startReCalcTourSearch', function (event) {
                        Search.startSearch(event.detail.formParams, event.detail.on, FIND_TYPE_RECOUNT);
                    });
                }
            }], [{
                key: "startSearch",
                value: function startSearch(query) {
                    var onEvents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                    var findType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                    var searchRequest = Object.assign({}, window.baseSearchRequest);
                    searchRequest.query = query;
                    if (findType !== null) {
                        if (!searchRequest.params) {
                            searchRequest.params = {};
                        }
                        searchRequest.params.findType = findType;
                    }
                    if (onEvents !== null) {
                        searchRequest.on = onEvents;
                    }

                    window.search.run(searchRequest);
                }
            }]);

            return Search;
        }();

        window.searchService = new Search();
        module.exports = Search;
    }, { "../../../include/search/_js/Tour": 2 }], 2: [function (require, module, exports) {
        Date.prototype.addDays = function (days) {
            var date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);

            return date;
        };

        /**
         * Координаты отеля
         * @property {number} lat широта
         * @property {number} long долгота
         */

        var TourHotelCoordinate = function TourHotelCoordinate(lat, long) {
            _classCallCheck(this, TourHotelCoordinate);

            this.lat = lat;
            this.long = long;
        };

        /**
         * @property {string||number} id id отеля
         * @property {number} category категория отеля
         * @property {string|number} class класс отеля (звездность, аппартоменты, хостел и т.д.)
         * @property {string} name наименование отеля
         * @property {string} photo основное фото отеля
         * @property {TourHotelCoordinate|null} coordinates координаты отеля
         * @property {number} rating рейтинг отеля
         * @property {number} reviewsCount количество отзывов
         * @property {number} salesCount количество продаж
         * @property {number} popularity популярность
         * @property {number} photosCount количество фотографий
         */


        var TourHotel = function TourHotel(t) {
            _classCallCheck(this, TourHotel);

            var isValidCoordinates = t[18] !== null && t[18] !== '' && t[18].length === 2;

            this.id = t[9] || 0;
            this.category = parseInt(t[38], 10) || 0;
            this.class = t[3];
            this.name = t[4];
            this.photo = t[11] || '';
            this.coordinates = isValidCoordinates ? new TourHotelCoordinate(t[18][0], t[18][1]) : null;
            this.rating = Number(t[19]);
            this.reviewsCount = Number(t[41]);
            this.popularity = Number(t[39]) || 0;
            this.salesCount = Number(t[59]);
            this.photosCount = Number(t[60]);
        };

        /**
         * Страна тура
         * @property {number|null} id id страны
         * @property {string} name наименование страны
         */


        var TourCountry = function TourCountry(id, name) {
            _classCallCheck(this, TourCountry);

            this.id = id;
            this.name = name;
        };

        /**
         * Регион тура
         * @property {number} id id региона
         * @property {string} name наименование региона
         */


        var TourRegion = function TourRegion(id, name) {
            _classCallCheck(this, TourRegion);

            this.id = id;
            this.name = name;
        };

        /**
         * Комната в отеле
         * @property {string} name наименование комнаты
         * @property {string} accommodation размещение
         */


        var TourRoom = function TourRoom(name, accommodation) {
            _classCallCheck(this, TourRoom);

            this.name = name || '';
            this.accommodation = accommodation || '';
        };

        /**
         * Питание
         * @property {string|number} id id питания
         * @property {string} name наименование питания
         * @property {string} shortName короткий код питания
         */


        var TourMeal = function TourMeal(id, name, shortName) {
            _classCallCheck(this, TourMeal);

            this.id = id || name;
            this.name = name;
            this.shortName = shortName;
        };

        /**
         * @property {number} adults взрослые
         * @property {number} child дети
         * @property {Array<number>} childAges возраст детей
         */


        var TourTourist = function TourTourist(adults, child, childAges) {
            _classCallCheck(this, TourTourist);

            this.adults = adults;
            this.child = child;
            this.childAges = childAges;
        };

        /**
         * Город вылета тура
         * @property {string} name наименование
         * @property {string} nameFrom наименование (в форме откуда)
         */


        var TourDepartCity = function TourDepartCity(name, nameFrom) {
            _classCallCheck(this, TourDepartCity);

            this.name = name;
            this.nameFrom = nameFrom;
        };

        /**
         * Цены за тур
         * @property {number} forOne за одного
         * @property {number} forTour за тур
         * @property {number} forNight за ночь (расчет идет от одного)
         * @property {number} withoutDiscountForOne без скидки за одного
         * @property {number} withoutDiscountForTour без скидки за тур
         */


        var TourPrice = function TourPrice(price, peopleCount, discount, nights) {
            _classCallCheck(this, TourPrice);

            var priceWithoutDiscount = discount ? Math.ceil(price / (1 - discount / 100)) : price;

            this.forOne = Math.floor(price / peopleCount);
            this.forNight = Math.floor(this.forOne / nights);
            this.forTour = price;
            this.withoutDiscountForOne = Math.floor(priceWithoutDiscount / peopleCount);
            this.withoutDiscountForTour = priceWithoutDiscount;
        };

        /**
         * @property {string} id id тура
         * @property {TourCountry} country страна
         * @property {TourRegion} region регион
         * @property {number} nights количество ночей
         * @property {number} days количество дней
         * @property {string} checkIn дата заселения
         * @property {string} checkOut дата выселения
         * @property {number} totalDays общее количество дней тура
         * @property {number} totalNights общее количество ночей тура
         * @property {TourHotel} hotel отель
         * @property {TourRoom} room комната
         * @property {TourMeal} meal питание
         * @property {TourTourist} tourist данные туристов
         * @property {TourDepartCity} departCity город вылета
         * @property {boolean} isBestPrice лучшая цена
         * @property {boolean} isFavoriteHotel todo: посмотреть надо, что за зверь
         * @property {boolean} isGDS тур расчитан на GDS тарифе авиабилетов
         * @property {boolean} isCombined комби тур
         * @property {string} currency валюта
         * @property {TourPrice} price цены за тур
         * @property {number} discount размер скидки
         * @property {boolean} hasSurcharges имеются доплаты
         */


        var Tour = function () {
            /**
             *
             * @param {array} t
             * @param {Object} searchReq
             */
            function Tour(t, searchReq) {
                _classCallCheck(this, Tour);

                var searchParams = searchReq && searchReq.searchInfo && searchReq.searchInfo.params ? searchReq.searchInfo.params : false;
                var peopleCount = searchParams ? searchParams.adult + searchParams.child : 0;

                this.id = t[10];
                this.country = new TourCountry(null, searchReq.getCountry());
                this.region = new TourRegion(t[62], t[0]);
                this.nights = Number(t[2]);
                this.days = this.nights + 1;
                this.totalNights = Number(t[37]);
                this.totalDays = this.totalNights + 1;

                // Поиск возвращает дату в виде d.m
                var date = new Date();
                var currentYear = date.getFullYear();
                var tourDate = t[1].split('.');
                var tourDay = tourDate[0];
                var tourMonth = tourDate[1];
                var tourYear = date.getMonth() + 1 > tourMonth ? currentYear + 1 : currentYear;

                this.checkIn = tourYear + "-" + tourMonth + "-" + tourDay;

                var checkInDate = new Date(tourYear, parseInt(tourMonth) - 1, tourDay);
                var checkOutDate = new Date(tourYear, parseInt(tourMonth) - 1, tourDay).addDays(this.nights);

                var checkOutYear = checkOutDate.getFullYear();
                var checkOutMonth = ('0' + (checkOutDate.getMonth() + 1).toString()).slice(-2);
                var checkOutDay = ('0' + checkOutDate.getDate().toString()).slice(-2);
                this.checkOut = checkOutYear + "-" + checkOutMonth + "-" + checkOutDay;

                this.hotel = new TourHotel(t);
                this.room = new TourRoom(t[5], t[34]);
                var mealId = isNaN(t[54]) ? 0 : Number(t[54]);
                this.meal = new TourMeal(mealId, t[6], t[29]);
                this.tourist = new TourTourist(searchParams ? searchParams.adult : 0, searchParams ? searchParams.child : 0, searchParams ? searchParams.childAges : []);
                this.departCity = new TourDepartCity(searchReq.getDepartCity(), searchReq.getDepartCityFrom());
                this.isBestPrice = Tour.booleanFormatter(t[21]);
                this.isFavoriteHotel = Tour.booleanFormatter(t[22]);
                this.isGDS = Tour.booleanFormatter(t[42]);
                this.isCombined = Tour.booleanFormatter(t[30]);
                this.currency = t[8];
                this.discount = t[15] || 0;
                this.price = new TourPrice(t[7], peopleCount, this.discount, this.nights);
                this.hasSurcharges = this.isGDS;
            }

            _createClass(Tour, null, [{
                key: "booleanFormatter",
                value: function booleanFormatter(value) {
                    return value === 1 || value === '1' || value === 'true' || value === true;
                }
            }]);

            return Tour;
        }();

        module.exports = Tour;
    }, {}] }, {}, [1]);